import React from 'react';
import {
  Accordion,
  Box,
  Text,
  HStack,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { FaBus, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import ActuacionMapPreview from './ActuacionMapPreview.jsx';

/**
 * Desplegable con ubicación y hora de salida del autobús (encuesta pública o ficha actuación).
 * @param {number | string | null | undefined} [lat] — latitud del punto de recogida (opcional, para mini mapa).
 * @param {number | string | null | undefined} [lng] — longitud del punto de recogida.
 */
export default function AutobusInfoAccordion({ ubicacion, horaSalida, lat, lng }) {
  const ub = (ubicacion || '').trim();
  const ho = (horaSalida || '').trim();
  const hasBusMap =
    lat != null &&
    lng != null &&
    !Number.isNaN(Number(lat)) &&
    !Number.isNaN(Number(lng));

  return (
    <Accordion.Root collapsible>
      <Accordion.Item
        borderWidth="1px"
        borderColor="blue.100"
        rounded="md"
        overflow="hidden"
        bg="blue.50"
        _dark={{ borderColor: 'blue.800', bg: 'rgba(30, 58, 138, 0.25)' }}
        value='item-0'>
        <h2>
          <Accordion.ItemTrigger py={2.5} px={3} _expanded={{ bg: 'blue.100' }} _dark={{ _expanded: { bg: 'blue.900' } }}>
            <HStack flex="1" textAlign="left" gap={2}>
              <Icon color="blue.600" _dark={{ color: 'blue.200' }} asChild><FaBus /></Icon>
              <Text fontWeight="600" fontSize="sm" color="blue.900" _dark={{ color: 'blue.100' }}>
                Información sobre el autobús
              </Text>
            </HStack>
            <Accordion.ItemIndicator color="blue.700" />
          </Accordion.ItemTrigger>
        </h2>
        <Accordion.ItemContent
          pb={3}
          pt={0}
          px={3}
          bg="white"
          _dark={{ bg: 'gray.800' }}
          animation='none'><Accordion.ItemBody>
            {!ub && !ho ? (
              <Text fontSize="sm" color="gray.600">
                La banda aún no ha indicado el punto de recogida ni la hora de salida del autobús.
              </Text>
            ) : (
              <VStack align="stretch" gap={3}>
                {ho ? (
                  <HStack align="start" gap={2}>
                    <Icon color="blue.500" mt={0.5} flexShrink={0} asChild><FaClock /></Icon>
                    <Box>
                      <Text fontSize="xs" fontWeight="700" color="gray.500">
                        Hora de salida del autobús
                      </Text>
                      <Text fontSize="sm">{ho}</Text>
                    </Box>
                  </HStack>
                ) : null}
                {ub ? (
                  <HStack align="start" gap={2}>
                    <Icon color="blue.500" mt={0.5} flexShrink={0} asChild><FaMapMarkerAlt /></Icon>
                    <Box>
                      <Text fontSize="xs" fontWeight="700" color="gray.500">
                        Ubicación del autobús
                      </Text>
                      <Text fontSize="sm">{ub}</Text>
                    </Box>
                  </HStack>
                ) : null}
                {hasBusMap ? (
                  <Box rounded="md" overflow="hidden" borderWidth="1px" borderColor="blue.200" _dark={{ borderColor: 'blue.700' }}>
                    <ActuacionMapPreview latAutobus={lat} lngAutobus={lng} height="160px" />
                  </Box>
                ) : null}
              </VStack>
            )}
          </Accordion.ItemBody></Accordion.ItemContent>
      </Accordion.Item>
    </Accordion.Root>
  );
}
